import styled, { createGlobalStyle } from 'styled-components';
import { Button, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Link } = Typography;

export const AuthContainer = styled.div`
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  max-width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 16px;
  box-sizing: border-box;
  flex-direction: column;

  * {
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    min-height: 100vh;
    min-height: 100dvh;
    padding: 20px 12px;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  @media (max-width: 480px) {
    min-height: 100vh;
    min-height: 100dvh;
    padding: 16px 10px;
    align-items: center;
    justify-content: center;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  @media (max-width: 360px) {
    min-height: 100vh;
    min-height: 100dvh;
    padding: 14px 8px;
    align-items: center;
    justify-content: center;
    padding-top: 14px;
    padding-bottom: 14px;
  }

  @media (max-width: 320px) {
    min-height: 100vh;
    min-height: 100dvh;
    padding: 12px 6px;
    align-items: center;
    justify-content: center;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const BackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
`;

export const AnimationBox = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const FormContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  min-width: 0;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-grow: 0;
  align-self: center;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    min-width: 0;
    padding: 0;
    flex-shrink: 0;
    flex-grow: 0;
    align-self: center;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    width: 100%;
    min-width: 0;
    padding: 0;
    flex-shrink: 0;
    flex-grow: 0;
    align-self: center;
  }

  @media (max-width: 360px) {
    max-width: 100%;
    width: 100%;
    min-width: 0;
    padding: 0;
    flex-shrink: 0;
    flex-grow: 0;
    align-self: center;
  }

  @media (max-width: 320px) {
    max-width: 100%;
    width: 100%;
    min-width: 0;
    padding: 0;
    flex-shrink: 0;
    flex-grow: 0;
    align-self: center;
  }
`;

export const FormCard = styled.div`
  background: transparent;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  isolation: isolate;

  @media (max-width: 768px) {
    padding: 24px 20px;
    border-radius: 12px;
    width: 100%;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 24px 18px;
    border-radius: 10px;
    width: 100%;
    max-width: 100%;
  }

  @media (max-width: 360px) {
    padding: 20px 16px;
    border-radius: 8px;
    width: 100%;
    max-width: 100%;
  }

  @media (max-width: 320px) {
    padding: 18px 14px;
    border-radius: 6px;
    width: 100%;
    max-width: 100%;
  }

  > * {
    position: relative;
    z-index: 2;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f7fafc' : '#1a202c')};
  line-height: 1.2;
  word-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 6px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 4px;
  }

  @media (max-width: 360px) {
    font-size: 16px;
  }
`;

export const Subtitle = styled.p`
  font-size: 14px;
  text-align: center;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#a0aec0' : '#718096')};
  margin-bottom: 24px;
  line-height: 1.5;
  word-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 18px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 14px;
    line-height: 1.4;
  }

  @media (max-width: 360px) {
    font-size: 11px;
    margin-bottom: 12px;
  }
`;

export const FormItem = styled.div`
  margin-bottom: 20px;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-bottom: 18px;
  }

  @media (max-width: 480px) {
    margin-bottom: 18px;
  }

  @media (max-width: 360px) {
    margin-bottom: 16px;
  }

  @media (max-width: 320px) {
    margin-bottom: 14px;
  }

  .ant-form-item {
    margin-bottom: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;

    .ant-form-item-label {
      padding-bottom: 0px !important;
      margin-bottom: 0 !important;
    }
  }

  .ant-input,
  .ant-input-password {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
`;

export const HelperText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#a0aec0' : '#718096')};
  margin-top: 4px;
  line-height: 1.4;

  @media (max-width: 480px) {
    font-size: 11px;
    margin-top: 2px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  position: relative;
  z-index: 2;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-top: 22px;
  }

  @media (max-width: 480px) {
    margin-top: 20px;
  }

  @media (max-width: 360px) {
    margin-top: 18px;
  }

  @media (max-width: 320px) {
    margin-top: 16px;
  }
`;

export const LinkText = styled.div`
  text-align: right;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow: hidden;
  margin-top: 4px;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    margin-top: 3px;
    margin-bottom: 12px;
    text-align: right;
  }

  @media (max-width: 480px) {
    margin-top: 2px;
    margin-bottom: 10px;
    text-align: right;
  }

  @media (max-width: 360px) {
    margin-top: 1px;
    margin-bottom: 8px;
    text-align: right;
  }

  a {
    font-size: 14px;
    display: inline-block;
    max-width: 100%;
    word-wrap: break-word;
    
    @media (max-width: 480px) {
      font-size: 13px;
    }

    @media (max-width: 360px) {
      font-size: 12px;
    }
  }
`;

export const SuccessMessage = styled.div`
  text-align: center;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(34, 197, 94, 0.15)' : 'rgba(34, 197, 94, 0.05)')};
  margin-bottom: 16px;
  width: 100%;

  ${Title} {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#ffffff' : '#0f5132')} !important;
    font-weight: 700 !important;
    margin-bottom: 8px !important;
  }

  ${Subtitle} {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#ffffff' : '#0f5132')} !important;
    opacity: 1 !important;
    margin-bottom: 0 !important;
    font-weight: ${({ theme }) => (theme.mode === 'dark' ? '500' : '600')} !important;
    
    &[style*="fontSize"] {
      color: ${({ theme }) => (theme.mode === 'dark' ? '#ffffff' : '#0f5132')} !important;
    }
  }

  strong {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#ffffff' : '#0f5132')} !important;
    font-weight: 700 !important;
  }

  @media (max-width: 768px) {
    padding: 14px;
    margin-bottom: 14px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 6px;
  }
`;

export const ErrorMessage = styled.div`
  text-align: center;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(239, 68, 68, 0.05)')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#fc8181' : '#dc2626')};
  margin-bottom: 16px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 14px;
    margin-bottom: 14px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 6px;
  }
`;

export const PrimaryButton = styled(Button)`
  height: 44px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  width: 100% !important;
  box-sizing: border-box;
  transition: all 0.3s ease !important;

  &:not(:disabled):not(.ant-btn-loading) {
    background-color: #2D6CCA !important;
    border-color: #2D6CCA !important;
  }

  &.ant-btn-loading {
    background-color: #5a8dd4 !important;
    border-color: #5a8dd4 !important;
    opacity: 0.8 !important;
  }

  &:hover:not(:disabled):not(.ant-btn-loading) {
    background-color: #2563c7 !important;
    border-color: #2563c7 !important;
  }

  &:disabled,
  &.ant-btn-disabled {
    background-color: #2D6CCA !important;
    color: #ffffff !important;
    cursor: not-allowed !important;
  }

  @media (max-width: 768px) {
    height: 44px !important;
    border-radius: 8px !important;
    font-size: 16px !important;
  }

  @media (max-width: 480px) {
    height: 44px !important;
    border-radius: 8px !important;
    font-size: 15px !important;
  }

  @media (max-width: 360px) {
    height: 42px !important;
    border-radius: 7px !important;
    font-size: 14px !important;
  }

  @media (max-width: 320px) {
    height: 40px !important;
    border-radius: 6px !important;
    font-size: 13px !important;
  }
`;

export const PasswordInputWrapper = styled.div`
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow: hidden;

  .ant-input-password {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-input-password-icon {
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    border-radius: 6px;
    padding: 4px;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 24px;
    height: 24px;
    flex-shrink: 0 !important;
    margin-left: 8px !important;

    @media (max-width: 480px) {
      width: 22px;
      height: 22px;
      padding: 3px;
      margin-left: 6px !important;
    }

    svg {
      transition: color 0.2s;
      color: #2D6CCA !important;
      font-size: 14px;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;

      @media (max-width: 480px) {
        font-size: 12px;
      }
    }

    &:hover {
      background-color: ${({ theme }) => 
        theme.mode === 'dark' 
          ? 'rgba(45, 108, 202, 0.2)' 
          : 'rgba(45, 108, 202, 0.1)'
      } !important;

      svg {
        color: #2D6CCA !important;
      }
    }
  }
`;

export const ResponsiveFormWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  z-index: 2;

  .ant-form {
    width: 100%;
    max-width: 100%;
    position: relative;
    box-sizing: border-box;
  }

  .ant-form-item {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;

    .ant-form-item-label {
      margin-bottom: 0 !important;
    }

    @media (max-width: 768px) {
      margin-bottom: 18px !important;
    }

    @media (max-width: 480px) {
      margin-bottom: 18px !important;
    }

    @media (max-width: 360px) {
      margin-bottom: 16px !important;
    }

    @media (max-width: 320px) {
      margin-bottom: 14px !important;
    }
  }

  .ant-form-item-label {
    padding-bottom: 0px !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 0 !important;


    label {
      font-size: 14px;
      font-weight: 500;
      white-space: normal;
      word-wrap: break-word;
      color: ${({ theme }) => (theme.mode === 'dark' ? '#f7fafc' : '#1a202c')} !important;
      line-height: 1.5;

      @media (max-width: 480px) {
        font-size: 13px;
      }

      @media (max-width: 360px) {
        font-size: 12px;
      }

      .ant-form-item-required::before {
        color: #ff4d4f;
        margin-right: 4px;
      }
    }
  }

  .ant-form-item-control {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .ant-input,
  .ant-input-password {
    width: 100% !important;
    max-width: 100% !important;
    font-size: 14px;
    padding: 8px 12px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 8px !important;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f7fafc' : '#1a202c')} !important;
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#2d3748' : '#ffffff')} !important;
    border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4a5568' : '#d9d9d9')} !important;
    display: flex !important;
    align-items: center !important;
    line-height: 1.5 !important;

    &:hover {
      border-color: ${({ theme }) => (theme.mode === 'dark' ? '#63b3ed' : '#40a9ff')} !important;
    }

    &:focus,
    &.ant-input-focused {
      border-color: ${({ theme }) => (theme.mode === 'dark' ? '#63b3ed' : '#40a9ff')} !important;
      box-shadow: ${({ theme }) => (theme.mode === 'dark' ? '0 0 0 2px rgba(99, 179, 237, 0.2)' : '0 0 0 2px rgba(24, 144, 255, 0.2)')} !important;
    }

    @media (max-width: 768px) {
      font-size: 14px;
      padding: 8px 12px;
      height: 40px;
      border-radius: 8px !important;
      display: flex !important;
      align-items: center !important;
    }

    @media (max-width: 480px) {
      font-size: 14px;
      padding: 8px 12px;
      height: 40px;
      border-radius: 8px !important;
      display: flex !important;
      align-items: center !important;
    }

    @media (max-width: 360px) {
      font-size: 13px;
      padding: 7px 11px;
      height: 38px;
      border-radius: 7px !important;
      display: flex !important;
      align-items: center !important;
    }

    @media (max-width: 320px) {
      font-size: 12px;
      padding: 6px 10px;
      height: 36px;
      border-radius: 6px !important;
      display: flex !important;
      align-items: center !important;
    }

    &::placeholder {
      font-size: 14px;
      color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.25)')} !important;
      opacity: 1;

      @media (max-width: 480px) {
        font-size: 13px;
      }

      @media (max-width: 360px) {
        font-size: 12px;
      }

      @media (max-width: 320px) {
        font-size: 11px;
      }
    }

    &::-webkit-input-placeholder {
      color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.25)')} !important;
      opacity: 1;
    }

    &::-moz-placeholder {
      color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.25)')} !important;
      opacity: 1;
    }

    &:-ms-input-placeholder {
      color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.25)')} !important;
      opacity: 1;
    }
  }

  .ant-input-password {
    display: flex !important;
    align-items: center !important;

    .ant-input {
      width: 100% !important;
      max-width: 100% !important;
      height: 100% !important;
      border: none !important;
      outline: none !important;
      padding: 0 !important;
      line-height: 1.5 !important;
      display: flex !important;
      align-items: center !important;
      flex: 1 !important;
    }
  }

  .ant-form-item-explain-error {
    font-size: 12px;
    word-wrap: break-word;

    @media (max-width: 480px) {
      font-size: 11px;
    }

    @media (max-width: 360px) {
      font-size: 10px;
    }
  }
`;

export const LoadingIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
  animation: spin 1s linear infinite;
  font-size: 14px;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-right: 6px;
  }
`;

export const HelpText = styled(Subtitle)`
  font-size: 12px;
  opacity: 0.75;
  text-align: center;
  margin-top: 16px;
  line-height: 1.5;
  padding: 12px;
  border-radius: 8px;
  background: ${({ theme }) => 
    theme.mode === 'dark' 
      ? 'rgba(255, 255, 255, 0.03)' 
      : 'rgba(0, 0, 0, 0.02)'
  };
  border: 1px solid ${({ theme }) => 
    theme.mode === 'dark' 
      ? 'rgba(255, 255, 255, 0.05)' 
      : 'rgba(0, 0, 0, 0.04)'
  };

  @media (max-width: 480px) {
    font-size: 11px;
    margin-top: 12px;
    padding: 10px;
  }

  @media (max-width: 360px) {
    font-size: 10px;
    margin-top: 10px;
    padding: 8px;
  }
`;

export const ModernFormCard = styled(FormCard)`
  background: ${({ theme }) => 
    theme.mode === 'dark' 
      ? 'rgba(26, 32, 44, 0.95)' 
      : 'rgba(255, 255, 255, 0.98)'
  };
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: ${({ theme }) => 
    theme.mode === 'dark' 
      ? '0 20px 60px rgba(0, 0, 0, 0.5), 0 8px 24px rgba(0, 0, 0, 0.3)' 
      : '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 24px rgba(0, 0, 0, 0.1)'
  };
  border: ${({ theme }) => 
    theme.mode === 'dark' 
      ? '1px solid rgba(255, 255, 255, 0.15)' 
      : '1px solid rgba(0, 0, 0, 0.08)'
  };
  padding: 32px 28px;
  max-width: 520px;
  position: relative;
  overflow: visible;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #2D6CCA 0%, #5a8dd4 50%, #2D6CCA 100%);
    border-radius: 16px 16px 0 0;
  }

  @media (max-width: 768px) {
    padding: 28px 24px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 24px 20px;
  }

  @media (max-width: 360px) {
    padding: 20px 18px;
  }
`;

export const ModernTitle = styled(Title)`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  background: ${({ theme }) => 
    theme.mode === 'dark' 
      ? 'linear-gradient(135deg, #f7fafc 0%, #e2e8f0 100%)' 
      : 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)'
  };
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
  position: relative;
  padding-bottom: 12px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, transparent, #2D6CCA, transparent);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 6px;
    padding-bottom: 10px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    margin-bottom: 4px;
    padding-bottom: 8px;
  }

  @media (max-width: 360px) {
    font-size: 22px;
    margin-bottom: 4px;
    padding-bottom: 8px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  gap: 16px;

  @media (max-width: 480px) {
    margin-bottom: 12px;
    gap: 12px;
  }
`;

export const IconCircle = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: ${({ theme }) => 
    theme.mode === 'dark' 
      ? 'linear-gradient(135deg, rgba(45, 108, 202, 0.2) 0%, rgba(45, 108, 202, 0.1) 100%)' 
      : 'linear-gradient(135deg, rgba(45, 108, 202, 0.1) 0%, rgba(45, 108, 202, 0.05) 100%)'
  };
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => 
    theme.mode === 'dark' 
      ? 'rgba(45, 108, 202, 0.3)' 
      : 'rgba(45, 108, 202, 0.2)'
  };
  box-shadow: 0 4px 12px rgba(45, 108, 202, 0.15);

  svg {
    font-size: 24px;
    color: #2D6CCA;
  }

  @media (max-width: 480px) {
    width: 48px;
    height: 48px;

    svg {
      font-size: 20px;
    }
  }

  @media (max-width: 360px) {
    width: 44px;
    height: 44px;

    svg {
      font-size: 18px;
    }
  }
`;

export const SectionSpacer = styled.div`
  height: 20px;

  @media (max-width: 480px) {
    height: 16px;
  }

  @media (max-width: 360px) {
    height: 12px;
  }
`;

export const ModernFormContainer = styled(FormContainer)`
  max-width: 520px;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 16px;
  }

  @media (max-width: 480px) {
    padding: 0 12px;
  }

  @media (max-width: 360px) {
    padding: 0 10px;
  }
`;

// Login Form Role Selection Styles
export const DropdownMenuStyle = createGlobalStyle<{ $isDark?: boolean }>`
  .login-role-dropdown {
    .ant-dropdown-menu {
      border-radius: 12px !important;
      padding: 8px !important;
      box-shadow: ${props => props.$isDark ? '0 4px 12px rgba(0, 0, 0, 0.5)' : '0 4px 12px rgba(0, 0, 0, 0.15)'} !important;
      background: ${props => props.$isDark ? '#2D3748' : '#fff'} !important;
      border: ${props => props.$isDark ? '1px solid #4A5568' : '1px solid #d9d9d9'} !important;
      min-width: 220px !important;
    }
    
    .ant-dropdown-menu-item {
      border-radius: 8px !important;
      padding: 12px 16px !important;
      margin: 4px 0 !important;
      transition: all 0.2s ease !important;
      
      &:hover {
        background-color: ${props => props.$isDark ? '#4a5568' : '#E6F4FF'} !important;
      }
    }
  }
`;

export const DropdownButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 0;
  position: relative;
  
  .ant-btn {
    height: 42px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    border-radius: 0 !important;
    transition: all 0.2s ease !important;
  }
  
  .ant-btn:first-child {
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
    flex: 1;
    padding: 0 16px !important;
    text-align: left !important;
  }
  
  .ant-btn:last-child {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    border-left: 1px solid rgba(255, 255, 255, 0.2) !important;
    padding: 0 12px !important;
    min-width: 44px !important;
    width: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    
    &:hover:not(:disabled):not(.ant-btn-loading) {
      background-color: #2563c7 !important;
      border-color: #2563c7 !important;
      border-left-color: rgba(255, 255, 255, 0.3) !important;
    }
    
    &:active:not(:disabled):not(.ant-btn-loading),
    &:focus:not(:disabled):not(.ant-btn-loading) {
      background-color: #2563c7 !important;
      border-color: #2563c7 !important;
      border-left-color: rgba(255, 255, 255, 0.3) !important;
    }
    
    &.ant-btn-primary:not(:disabled):not(.ant-btn-loading) {
      background-color: #2D6CCA !important;
      border-color: #2D6CCA !important;
    }
    
    &.ant-dropdown-open,
    &[aria-expanded="true"] {
      background-color: #2563c7 !important;
      border-color: #2563c7 !important;
      border-left-color: rgba(255, 255, 255, 0.3) !important;
    }
    
    svg {
      font-size: 12px !important;
    }
  }
`;

export const RoleLabel = styled.span<{ $hasRole?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  opacity: ${props => props.$hasRole ? 1 : 0.7};
`;

export const LoginButton = styled(PrimaryButton)`
  flex: 1;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  
  &.ant-btn-loading {
    .ant-btn-loading-icon {
      margin-right: 0 !important;
      margin-inline-end: 8px !important;
    }
    
    .anticon {
      margin-right: 0 !important;
      margin-inline-end: 8px !important;
    }
  }
  
  > span {
    display: inline-flex !important;
    align-items: center !important;
    white-space: nowrap !important;
  }
`;

export const DropdownArrowButton = styled(PrimaryButton)`
  padding: 0 12px !important;
  min-width: 44px !important;
  width: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  
  &:hover:not(:disabled):not(.ant-btn-loading) {
    background-color: #2563c7 !important;
    border-color: #2563c7 !important;
  }
  
  &:active:not(:disabled):not(.ant-btn-loading),
  &:focus:not(:disabled):not(.ant-btn-loading) {
    background-color: #2563c7 !important;
    border-color: #2563c7 !important;
  }
  
  &.ant-btn-primary:not(:disabled):not(.ant-btn-loading) {
    background-color: #2D6CCA !important;
    border-color: #2D6CCA !important;
  }
  
  &.ant-dropdown-open,
  &[aria-expanded="true"] {
    background-color: #2563c7 !important;
    border-color: #2563c7 !important;
  }
`;

export const DropdownIcon = styled(FontAwesomeIcon)`
  font-size: 12px !important;
`;

export const RoleMenuItemWrapper = styled.div<{ $isDark?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
`;

export const RoleMenuItemTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
`;

export const RoleMenuItemDescription = styled.span<{ $isDark?: boolean }>`
  font-size: 12px;
  color: ${props => props.$isDark ? '#a0aec0' : '#8c8c8c'};
  line-height: 1.3;
`;

export const ForgotPasswordLink = styled(Link)`
  font-size: 14px;
`;

// Role Button Group Styles
export const RoleButtonGroup = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
  margin-top: 12px;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 6px;
  }
`;

export const RoleButton = styled.button<{ $isSelected?: boolean }>`
  flex: 1;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1.5px solid ${props => props.$isSelected ? '#2D6CCA' : '#d9d9d9'};
  background-color: ${props => props.$isSelected ? '#2D6CCA' : 'transparent'};
  color: ${props => props.$isSelected ? '#ffffff' : '#595959'};
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  
  &:hover:not(:disabled) {
    border-color: #2D6CCA;
    background-color: ${props => props.$isSelected ? '#2563c7' : 'rgba(45, 108, 202, 0.1)'};
    color: ${props => props.$isSelected ? '#ffffff' : '#2D6CCA'};
  }
  
  &:active:not(:disabled) {
    transform: scale(0.98);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  @media (max-width: 480px) {
    width: 100%;
  }
`;
